import {Component, ElementRef, ViewEncapsulation} from '@angular/core';
import {StandaloneComponent} from '../standalone.component';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent extends StandaloneComponent {
  constructor(
    route: ActivatedRoute,
    router: Router,
    hostElement: ElementRef
  ) {
    super(route, router, hostElement);
  }
}
